<template>
    <div class="new-researchers ma-5 pa-3">
        <h3>業務委託契約の発行</h3>
        <v-card
        v-for="researcher in newResearchers" :key="researcher.email"
        >
            <v-row no-gutter class="ma-3">
                <v-col cols="2" class="">
                    <v-row justify="center">
                        <h5>ID</h5>
                    </v-row>
                    <hr class="dashed my-1">
                    <v-row justify="center" class="text-center">
                        <v-col cols="12">
                            <div>{{researcher.name[0]}} {{researcher.name[1]}}</div>
                            <div>{{researcher.email}}</div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="4" class="">
                    <v-row justify="center">
                        <h5>住所</h5>
                    </v-row>
                    <hr class="dashed my-1">
                    <v-row justify="center" class="text-center">
                        <v-col cols="12">
                            <p>〒{{researcher.address.postalCode}}<br>
                            {{researcher.address.address}}</p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="2" class="">
                    <v-row justify="center">
                        <h5>登録日</h5>
                    </v-row>
                    <hr class="dashed my-1">
                    <v-row justify="center" align="center" class="text-center">
                        <v-col cols="12">
                            <div>{{new Date(researcher.signup_time.seconds*1000)}}</div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="3" class="">
                    <v-row justify="center">
                        <h5>契約状態</h5>
                    </v-row>
                    <hr class="dashed my-1">
                    <v-row dense no-gutter justify="center" class="mx-1">
                        <v-col cols="6" class="">
                            <v-row justify="center" align="center">
                                <span class="caption mx-1">送信済み</span>
                                <v-checkbox v-model="contractStatus.sent"></v-checkbox>
                            </v-row>
                        </v-col>
                        <v-col cols="6">
                            <v-row justify="center" align="center">
                                <span class="caption mx-1">契約済み</span>
                                <v-checkbox v-model="contractStatus.signed"></v-checkbox>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="1" class="">
                    <v-row justify="center">
                        <h5>契約作成</h5>
                    </v-row>
                    <hr class="dashed my-1">
                    <v-row justify="center" align="center">
                        <!-- <v-col cols="12"> -->
                            <v-btn x-small class="mt-3" @click="onDownloadPDFClickWithPDFMake(researcher)">PDFを作成</v-btn>
                        <!-- </v-col> -->
                    </v-row>
                </v-col>
                <personalInfoAgreement :researcher = 'researcher' />
                <nda :researcher = 'researcher'/>
                <ctpd :researcher = 'researcher'/>
            </v-row>
            
        </v-card>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {db} from '@/fb'
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import personalInfoAgreement from '@/components/researchers/docs/personal_info_agreement.vue'
import nda from '@/components/researchers/docs/nda.vue'
import ctpd from '@/components/researchers/docs/ctpd.vue'
export default {
    name:"newResearchers",
    components:{
        personalInfoAgreement,
        nda,
        ctpd,
    },
    data(){
        return{
            newResearchers:[],
            contractStatus:{
                sent:false,
                signed:false,
            }
        }
    },
    async created(){
        let ref = db.collection('researchers').where('contract_signed','==',false)
        await ref.get().then(snap=>{
            snap.forEach(doc=>{
                this.newResearchers.push(doc.data())
            })
        })
    },
    methods: {
        onDownloadPDFClickWithPDFMake(researcher) {
            pdfMake.fonts = {
                GenShin: {
                    normal: 'GenShinGothic-Normal-Sub.ttf',
                    bold: 'GenShinGothic-Normal-Sub.ttf',
                    italics: 'GenShinGothic-Normal-Sub.ttf',
                    bolditalics: 'GenShinGothic-Normal-Sub.ttf',
                },
            };
            const defaultStyle = 'GenShin';

            // PDF出力する内容の定義
            const dateOfCreation = new Date();
            const docDefinition = {
                content: [
                    {
                        text: '業務委託契約書',
                        style: 'header',
                        alignment: 'center'
                    },
                    {
                        text: `\n\n株式会社 ＴＰＯ（以下「甲」という）と ${researcher.name[1]+' '+researcher.name[0]} (以下「乙」という）とは、甲の注文に係る業務の請負処理について、次の通り業務委託契約を締結する。`,
                        style: 'text',
                        alignment: 'center'
                    },
                    {
                        type: 'none',
                        pageBreak: 'after',
                        ul: [
                                ['\n第1条	契約の目的',
                                    {
                                        ol:[
                                            '本契約に基づく委託業務の範囲および内容は、別途業務注文書に定める通りとする。',
                                            '乙は、甲に対し前項の業務の完成の責任と義務を負い、甲は発注者として乙の業務遂行に必要な協力義務を負う。'
                                        ]
                                    }
                                ],
                                ['\n第2条	報酬',
                                    {
                                        ol:[
                                            '本契約に基づき甲が乙に支払う報酬の額は、別途業務注文書に定める通りとする。',
                                            '報酬の支払い方法については、乙が当月分を当月末締めにて甲に請求し、甲は翌月末日までに乙が指定する銀行口座に振り込み支払うものとする。支払いに生じる振込み手数料は、甲の負担とする。',
                                            '経済状況の変化、物価の上昇、法令の変更、契約業務内容の変更、その他報酬額の変更を必要とする事由が生じた場合には、契約期間中であっても、甲乙協議の上、報酬額を改定することができる。',
                                            '本契約に定めるもの以外の特別な業務等を請負処理した場合には、甲は別途精算して支払うものとする。',
                                            '乙は、甲の負担にかかる費用を立て替えることができる。この場合の精算については、第2項に準ずる。'
                                        ]
                                    }
                                ],
                                ['\n第3条	契約期間',
                                    {
                                        ol:[
                                            `本契約の有効期間は、令和${dateOfCreation.getFullYear()-2018}年${dateOfCreation.getMonth()+1}月${dateOfCreation.getDate()}日から令和${dateOfCreation.getFullYear()-2017}年${dateOfCreation.getMonth()+1}月${dateOfCreation.getDate()}日までとする。ただし、当事者のいずれからも期間満了の1か月前までに書面による意思表示がない場合は、同一契約でさらに１年間更新するものとし、以降も同様とする。なお、第2条の報酬等については本契約更新の都度甲、乙協議する。`,
                                        ]
                                    }
                                ],
                                ['\n第4条	契約業務の履行',
                                    {
                                        ol:[
                                            "本契約の履行にあたり乙は、甲の業務注文書に従うとともに、日本国内における関係諸法令を守り、注文の趣旨に従い誠実かつ善良なる管理者の注意をもって、処理しなければならない。",
                                        ]                                         
                                    }
                                ],
                                ['\n第5条	注文上の指図、報告',
                                    {
                                        ol:[
                                            '乙は、甲の業務注文書に基づく本契約の請負処理については、別途定める業務注文書に基づき業務を実施するが、必要に応じ甲に注文上の指図を求めることができ、甲は必要に応じて注文上の指図を行う。',
                                            '乙は、必要に応じ甲からの要求があれば報告書等の書面をもって、業務の処理状況を速やかに甲に報告するものとする',
                                            '甲は、いつでも乙に対し契約業務の処理状況の報告を求めることができる。'
                                        ]                                         
                                    }
                                ],
                                ['\n\n第6条　　労働法上の責任',
                                    {
                                        ol:[
                                            '乙は、甲が委託する業務を請け負うものであり、甲の労働者ではない。したがって、業務上の災害など万一の場合においても、労働者としての補償を甲に対して求めることはできないものとする。',
                                        ]                                         
                                    }
                                ],
                                ['\n第7条　　規律維持',
                                    {
                                        ol:[
                                            '乙は、甲に対し本契約の処理にあたり、甲の秩序規律を保持し、風紀の維持に責任を負い、秩序ある業務処理に努め、甲の信用を維持し、甲および甲の取引先等に迷惑をかけないものとする。',
                                        ]                                         
                                    }
                                ],
                                ['\n第8条　　守秘義務・秘密情報管理',
                                    {
                                        ol:[
                                            '甲および乙は、本契約の履行にあたって知り得た相互の秘密を第三者に漏らしてはならない。特に乙は、甲から業務処理のために預かった資料・データ等の保管に万全を尽くし、外部に漏洩しないように措置をとらなければならない。',
                                            '本契約の履行に際し、甲の保有する秘密情報等を乙に委託または利用させるにあたっては、別に定める「秘密保持誓約書」による。',
                                        ]                                         
                                    }
                                ],
                                ['\n第9条　　再委託',
                                    {
                                        ol:[
                                            '乙は、甲の事前の書面による承諾がなければ、本件業務の全て又は一部を、第三者（以下「再委託先」という。）に再委託することができないものとする。乙が書面による承諾に基づいて本件業務を再委託する場合には、乙は再委託先につき、本契約において乙が甲に対して負う義務と同一の義務を遵守させなければならない。',
                                        ]                                         
                                    }
                                ],
                                ['\n第10条	注文上の指図、報告',
                                    {
                                        ol:[
                                            '本契約の履行により作成された成果物がある場合においては、当該成果物に含まれる著作権その他の権利は、甲に帰属する。',
                                            '乙は、本契約の履行により作成された成果物が、第三者の著作権、肖像権その他いかなる権利も侵害するものではなく、かつ、合法的なものであることをそれぞれ保証する。',
                                            '万一前項に関して第三者から異議、苦情等の申立あるいは実費の請求または対価の請求、損害賠償請求等があった場合には、弁護士費用も含めて、乙の責任と負担においてこれを処理し、甲には一切迷惑、損害をかけないものとする'
                                        ]                                         
                                    }
                                ],
                                ['\n第11条　　業務の処理責任',
                                    {
                                        ol:[
                                            '乙の行う本契約の処理につき瑕疵があり、または善良なる管理者の注意を欠いたため不完全な処理が行われた場合には、乙は甲に対し直ちに完全な履行となるよう追完を行い、または同時に損害賠償の責に任ずる。ただし、乙の予見できないとき、または甲の提供した情報、データ、備品等の瑕疵による場合等乙の責任に基づかない場合にはこの限りでない。',
                                        ]                                         
                                    }
                                ],
                                ['\n第12条　　損害賠償の責任',
                                    {
                                        ol:[
                                            '本契約の処理中、乙の故意または過失その他乙の責に帰すべき事由により、甲もしくは第三者に与えた損害に対し、乙は損害賠償の責任を負う。その賠償額については、甲乙協議の上これを定める。',
                                        ]                                         
                                    }
                                ],
                                ['\n\n第13条    暴力団等反社会的勢力の排除',
                                    {
                                        ol:[
                                            '乙は、甲に対し、本件契約時において、乙が暴力団、暴力団員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治運動標ぼうゴロ、特殊知能暴力集団、その他反社会的勢力(以下｢暴力団等反社会的勢力｣という)に該当しないことを表明し、かつ将来にわたっても該当しないことを確約する。',
                                            '乙は、甲が前項の該当性の判断のために調査を要すると判断した場合、その調査に協力し、これに必要と判断する資料を提出しなければならない。',
                                            '乙は、本条に関連し、甲が指定する「確認書」を提出しなければならない。'
                                        ]                                         
                                    }
                                ],
                                ['\n第14条　　契約違反による即時解除',
                                    {
                                        ol:[
                                            '告を要せず、直ちに本契約を解除できるものとする。契約が解除された場合において、乙は原状に回復し、甲または甲の指定する者に対し本件契約業務の円滑な引き継ぎをし、業務処理の継続に支障がないよう協力する義務を負う',
                                            {   
                                                separator: ['(', ')'],
                                                ol:[
                                                    '本契約に定める事項に違反し、または履行を怠ったとき。',
                                                    '財産上の信用にかかわる差押え、仮差押え、仮処分を受け、または、競売、強制執行、滞納処分等を受けたとき。',
                                                    '破産、民事再生、会社整理、会社更生の申立てがあったとき。',
                                                    '営業を廃止しまたは清算に入ったとき。',
                                                    '乙が暴力団等反社会的勢力に属すると判明したとき。',
                                                    'その他、甲または乙の責に帰すべき事由の発生により本契約を継続しがたいとき。',
                                                ]
                                            }
                                        ]                                         
                                    }
                                ],
                                ['\n第15条　　契約の解除',
                                    {
                                        ol:[
                                            '甲または乙が前条の場合以外で契約有効期間中に本件契約を解除しようとする場合は、1か月前までに書面をもってその旨を相手方に通知し、甲乙協議するものとする。ただし、契約の解除が相手方に不利な時期である場合は、その損害を賠償しなければならない。',
                                        ]                                         
                                    }
                                ],
                                ['\n第16条　　譲渡・担保の禁止',
                                    {
                                        ol:[
                                            '甲乙ともに、本契約上の地位を第三者に譲渡し、または本契約上の権利を譲渡もしくは担保に供することはできない。',
                                        ]                                         
                                    }
                                ],
                                ['\n第17条    管轄',
                                    {
                                        ol:[
                                            '本契約について訴訟の必要が生じた場合には、東京地方裁判所を第一審の専属合意管轄裁判所とする。',
                                        ]                                         
                                    }
                                ],
                                ['\n第18条  　その他',
                                    {
                                        ol:[
                                            '本契約に定めのない事項または疑義が生じた事項については、信義誠実の原則に従い甲乙協議し、円満に解決を図るものとする。',
                                        ]                                         
                                    }
                                ],
                                [
                                    '\n以上、本契約締結の証として本書２通を作成し、甲乙記名押印のうえ、各１通を保有する。'
                                ]

                        ]
                    },
                    {
                        columns:[
                            {   
                                width:300,
                                text:''
                                
                            },
                            {
                                type:'none',
                                ol:[
                                    `令和 ${dateOfCreation.getFullYear()-2018} 年 ${dateOfCreation.getMonth()+1} 月 ${dateOfCreation.getDate()} 日`,
                                    '\n甲	東京都港区六本木6-6-2\nフラット六本木301\n株式会社ＴＰＯ\n代表取締役　マニヤン 麻里子',
                                    `\n乙	${researcher.name[1]+' '+researcher.name[0]}`,
                                ]
                                
                            },
                        ],
                    },
                    {
                        text: `\n\n\n\n\n\n\n\n業務注文書`,
                        style: 'header',
                        alignment: 'center'
                    },
                    {   
                        type:'none',
                        ol:[
                            '\n1. 業務委託契約第1条に定める個別的な業務委託契約に基づく業務委託の内容および報酬は、次の通りとする。',
                            {
                                style: 'tableExample',
                                table: {
                                    body: [
                                        ['委託業務内容', '報酬','備考'],
                                        ['甲が、コーポレート・コンシェルジュ業務を提供するに当たり、顧客企業の従業員から受ける依頼に関する調査(問い合わせ、レポート作成等を含む)', '1調査案件(問い合わせ、レポート作成等を含む)当たりの報酬額は都度提示する', '']
                                    ]
                                }
                            },
                            '2. 甲は乙に対し、前項以外の特別な業務を依頼した場合には、前項の報酬とは別途支払うものとする。',
                            '3. 前各項に定める業務委託の内容および報酬については、本契約期間中であったとしても、甲乙協議の上変更する場合がある。',
                        ]
                    },
                ],
                defaultStyle: {
                    font: defaultStyle,
                },
                styles: {
                    header: {
                        fontSize: 18,
                    },
                    subheader: {
                        fontSize: 10.5,
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                },
            };

            // pdfMakeでのPDF出力
            pdfMake.createPdf(docDefinition).open();
        },
    },
}
</script>

<style>
    hr.dashed {
    border-top: 1px dashed #bbb;
    }
</style>